enum PciDashboardSummaryType {
  County = "County",
  Specialty = "Specialty",
}

export { PciDashboardSummaryType };
